import { render, staticRenderFns } from "./Seat.vue?vue&type=template&id=bb7c9782"
import script from "./Seat.vue?vue&type=script&lang=js"
export * from "./Seat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports